@if (showPanel) {
  <div
    class="filter-container"
    [style.top.px]="topPosition"
    [style.right.px]="rightPosition"
  >
    <div class="filter-panel">
      <div class="panel-title">
        <hyperkit-typography variant="h4" align="left" color="primary"
          >Filters</hyperkit-typography
        >
      </div>
      <!-- Use async pipe once and assign it to a local variable -->
      @if (dashboardState$ | async; as dashboardState) {
        <!-- Environment Selection (Multi-select) -->
        <div class="filter-section">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >Environment</hyperkit-typography
          >
          <dashboard-environment-filter
            [filter]="dashboardState.filter"
            field="environments"
            [data]="environments"
            textField="name"
            valueField="id"
          ></dashboard-environment-filter>
        </div>
        <!-- Priority Selection (Multi-select) -->
        <div class="filter-section">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >Priority</hyperkit-typography
          >
          <dashboard-tag-filter
            [filter]="dashboardState.filter"
            field="priority"
            [data]="priorityFilters"
            textField="text"
            valueField="value"
          ></dashboard-tag-filter>
        </div>
        <!-- Outcome Selection (Multi-select) -->
        <div class="filter-section">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >Outcome</hyperkit-typography
          >
          <dashboard-tag-filter
            [filter]="dashboardState.filter"
            field="outcome"
            [data]="outcomeFilters"
            textField="text"
            valueField="value"
          ></dashboard-tag-filter>
        </div>
        <!-- Status Selection (Multi-select) -->
        <div class="filter-section">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >Status</hyperkit-typography
          >
          <dashboard-tag-filter
            [filter]="dashboardState.filter"
            field="status"
            [data]="statusFilters"
            textField="text"
            valueField="value"
          ></dashboard-tag-filter>
        </div>
        <!-- Assignee Selection (Single-select with Search) -->
        <div class="filter-section">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >Assignee</hyperkit-typography
          >
          <dashboard-dropdown-filter
            [filter]="dashboardState.filter"
            field="assignee"
            [data]="users$ | async"
            textField="fullName"
            valueField="id"
          ></dashboard-dropdown-filter>
        </div>
        <!-- Author Selection (Single-select with Search) -->
        <div class="filter-section">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >Author</hyperkit-typography
          >
          <dashboard-dropdown-filter
            [filter]="dashboardState.filter"
            field="author"
            [data]="users$ | async"
            textField="fullName"
            valueField="id"
          ></dashboard-dropdown-filter>
        </div>
      }
      <!-- Buttons -->
      <div class="filter-buttons">
        <hyperkit-button
          size="small"
          (click)="resetFilters()"
          variant="standard"
          color="secondary"
          text="Reset"
        ></hyperkit-button>
        <hyperkit-button
          size="small"
          (click)="applyFilters()"
          variant="standard"
          color="tertiary"
          text="Apply"
        ></hyperkit-button>
      </div>
    </div>
  </div>
}
